import { render, staticRenderFns } from "./settings-view.vue?vue&type=template&id=a69552fc&scoped=true"
import script from "./settings-view.vue?vue&type=script&lang=js"
export * from "./settings-view.vue?vue&type=script&lang=js"
import style0 from "./settings-view.vue?vue&type=style&index=0&id=a69552fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69552fc",
  null
  
)

export default component.exports